var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Card validate")]),_c('Form',{attrs:{"valid-card":_vm.validCard},on:{"notifyMsg":_vm.notifyHandler}}),_c('Notify',{attrs:{"notify":_vm.notifyMsg}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }